import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LANGUAGES = {
  it: { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  en: { code: 'en', name: 'English', flag: '🇬🇧' },
  fr: { code: 'fr', name: 'Français', flag: '🇫🇷' },
  de: { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  es: { code: 'es', name: 'Español', flag: '🇪🇸' },
};

// Static translations for UI elements
export const UI_TRANSLATIONS = {
  it: {
    home: 'Home',
    team: 'Il Team',
    aboutUs: 'Chi Siamo',
    projects: 'Progetti',
    events: 'Eventi',
    blog: 'Blog',
    gallery: 'Gallery',
    crags: 'Falesie',
    howToArrive: 'Come Arrivare',
    accommodation: 'Dove Pernottare',
    donations: 'Donazioni',
    contact: 'Contatti',
    readMore: 'Leggi di più',
    viewAll: 'Vedi tutti',
    donate: 'Dona Ora',
    send: 'Invia',
    name: 'Nome',
    email: 'Email',
    message: 'Messaggio',
    subject: 'Oggetto',
    phone: 'Telefono',
    address: 'Indirizzo',
    routes: 'Vie',
    grade: 'Grado',
    length: 'Lunghezza',
    type: 'Tipo',
    exposure: 'Esposizione',
    rockType: 'Tipo di roccia',
    approachTime: 'Tempo di avvicinamento',
    pathType: 'Tipo di sentiero',
    gpsCoordinates: 'Coordinate GPS',
    totalRoutes: 'Vie totali',
    gradeRange: 'Range di gradi',
    filterByGrade: 'Filtra per grado',
    allGrades: 'Tutti i gradi',
    latestRoutes: 'Ultime vie chiodate',
    upcomingEvents: 'Prossimi eventi',
    ourMission: 'La nostra missione',
    ourHistory: 'La nostra storia',
    supportUs: 'Supportaci',
    donationAmount: 'Importo donazione',
    customAmount: 'Importo personalizzato',
    loginAdmin: 'Accesso Admin',
    password: 'Password',
    login: 'Accedi',
    logout: 'Esci',
    dashboard: 'Dashboard',
    settings: 'Impostazioni',
    status: 'Stato',
    completed: 'Completato',
    inProgress: 'In corso',
    date: 'Data',
    location: 'Luogo',
    category: 'Categoria',
    tags: 'Tag',
    search: 'Cerca',
    noResults: 'Nessun risultato',
    loading: 'Caricamento...',
    error: 'Errore',
    success: 'Successo',
    messageSent: 'Messaggio inviato con successo',
    requiredField: 'Campo obbligatorio',
    invalidEmail: 'Email non valida',
    heroTitle: 'SCOPRI L\'ARRAMPICATA SULLE MADONIE',
    heroSubtitle: 'Esplora le falesie di Caltavuturo',
    exploreNow: 'Esplora ora',
    ourHistory: 'La nostra storia',
    climbingHistory: '',
    climbingHistoryText: 'Caltavuturo Climbing nasce dall\'eredità preziosa lasciata da Cabeci Climbing, storico gruppo di appassionati che ha contribuito in modo determinante alla chiodatura della maggior parte delle falesie presenti nel territorio di Caltavuturo. Da questa base solida prende vita una nuova generazione di giovani climber locali, animati dalla stessa passione e dal desiderio di valorizzare un patrimonio verticale unico.\n\nL\'associazione si impegna a promuovere l\'arrampicata sportiva come disciplina, stile di vita e occasione di incontro con la natura, portando avanti progetti di apertura e chiodatura di nuove vie in falesie ancora inesplorate. Parallelamente organizza eventi, raduni e giornate dedicate alla diffusione della cultura dell\'arrampicata, con l\'obiettivo di far conoscere le straordinarie pareti delle Madonie a livello regionale, nazionale e internazionale.\n\nCaltavuturo Climbing è comunità, passione e visione: un punto di riferimento per chi vive la roccia con rispetto, entusiasmo e spirito di condivisione, con lo sguardo sempre rivolto verso nuove linee da tracciare e nuovi orizzonti da raggiungere.',
    homeHistoryText: 'Caltavuturo Climbing è un gruppo di giovani climber di Caltavuturo uniti dall\'amore per la roccia e per le nostre montagne. Portiamo avanti l\'eredità di Cabeci Climbing, prendendoci cura delle falesie esistenti e sviluppando nuove vie per far crescere l\'arrampicata sportiva nel territorio.\n\nCon eventi, raduni e nuovi progetti vogliamo condividere la bellezza di scalare nelle Madonie e far conoscere queste pareti a chi arriva da vicino e da lontano. Per noi è passione, comunità e libertà verticale.',
    missionTitle: 'La nostra missione',
    missionText: 'Promuovere l\'arrampicata sportiva in Sicilia, sviluppare nuovi settori, mantenere le falesie esistenti e creare una comunità inclusiva di climber.',
    donationCTA: 'Aiutaci a sviluppare nuove vie',
    footerText: 'Associazione sportiva dedicata alla promozione dell\'arrampicata in Sicilia.',
  },
  en: {
    home: 'Home',
    team: 'The Team',
    aboutUs: 'About Us',
    projects: 'Projects',
    events: 'Events',
    blog: 'Blog',
    gallery: 'Gallery',
    crags: 'Crags',
    howToArrive: 'How to Arrive',
    accommodation: 'Accommodation',
    donations: 'Donations',
    contact: 'Contact',
    readMore: 'Read more',
    viewAll: 'View all',
    donate: 'Donate Now',
    send: 'Send',
    name: 'Name',
    email: 'Email',
    message: 'Message',
    subject: 'Subject',
    phone: 'Phone',
    address: 'Address',
    routes: 'Routes',
    grade: 'Grade',
    length: 'Length',
    type: 'Type',
    exposure: 'Exposure',
    rockType: 'Rock type',
    approachTime: 'Approach time',
    pathType: 'Path type',
    gpsCoordinates: 'GPS Coordinates',
    totalRoutes: 'Total routes',
    gradeRange: 'Grade range',
    filterByGrade: 'Filter by grade',
    allGrades: 'All grades',
    latestRoutes: 'Latest bolted routes',
    upcomingEvents: 'Upcoming events',
    ourMission: 'Our mission',
    ourHistory: 'Our history',
    supportUs: 'Support us',
    donationAmount: 'Donation amount',
    customAmount: 'Custom amount',
    loginAdmin: 'Admin Login',
    password: 'Password',
    login: 'Login',
    logout: 'Logout',
    dashboard: 'Dashboard',
    settings: 'Settings',
    status: 'Status',
    completed: 'Completed',
    inProgress: 'In progress',
    date: 'Date',
    location: 'Location',
    category: 'Category',
    tags: 'Tags',
    search: 'Search',
    noResults: 'No results',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    messageSent: 'Message sent successfully',
    requiredField: 'Required field',
    invalidEmail: 'Invalid email',
    heroTitle: 'CLIMBING IN SICILY',
    heroSubtitle: 'Discover the crags of Caltavuturo',
    exploreNow: 'Explore now',
    climbingHistory: 'Climbing history',
    climbingHistoryText: 'Caltavuturo Climbing was born from the precious legacy left by Cabeci Climbing, a historic group of enthusiasts who contributed decisively to bolting most of the crags in the Caltavuturo area. From this solid foundation, a new generation of young local climbers comes to life, driven by the same passion and the desire to enhance a unique vertical heritage.\n\nThe association is committed to promoting sport climbing as a discipline, lifestyle and opportunity to connect with nature, carrying out projects for opening and bolting new routes in still unexplored crags. At the same time, it organizes events, gatherings and days dedicated to spreading climbing culture, with the aim of making the extraordinary walls of the Madonie known at regional, national and international level.\n\nCaltavuturo Climbing is community, passion and vision: a reference point for those who live the rock with respect, enthusiasm and a spirit of sharing, always looking towards new lines to trace and new horizons to reach.',
    homeHistoryText: 'Caltavuturo Climbing is a group of young climbers from Caltavuturo united by their love for rock and our mountains. We carry on the legacy of Cabeci Climbing, taking care of existing crags and developing new routes to help sport climbing grow in the territory.\n\nWith events, gatherings and new projects, we want to share the beauty of climbing in the Madonie and introduce these walls to those who come from near and far. For us, it\'s passion, community and vertical freedom.',
    missionTitle: 'Our mission',
    missionText: 'To promote sport climbing in Sicily, develop new sectors, maintain existing crags and create an inclusive climbing community.',
    donationCTA: 'Help us develop new routes',
    footerText: 'Sports association dedicated to promoting climbing in Sicily.',
  },
  fr: {
    home: 'Accueil',
    team: 'L\'équipe',
    aboutUs: 'Qui sommes-nous',
    projects: 'Projets',
    events: 'Événements',
    blog: 'Blog',
    gallery: 'Galerie',
    crags: 'Falaises',
    howToArrive: 'Comment arriver',
    accommodation: 'Hébergement',
    donations: 'Dons',
    contact: 'Contact',
    readMore: 'Lire la suite',
    viewAll: 'Voir tout',
    donate: 'Faire un don',
    send: 'Envoyer',
    name: 'Nom',
    email: 'Email',
    message: 'Message',
    subject: 'Sujet',
    phone: 'Téléphone',
    address: 'Adresse',
    routes: 'Voies',
    grade: 'Cotation',
    length: 'Longueur',
    type: 'Type',
    exposure: 'Exposition',
    rockType: 'Type de roche',
    approachTime: 'Temps d\'approche',
    pathType: 'Type de sentier',
    gpsCoordinates: 'Coordonnées GPS',
    totalRoutes: 'Voies totales',
    gradeRange: 'Plage de cotations',
    filterByGrade: 'Filtrer par cotation',
    allGrades: 'Toutes les cotations',
    latestRoutes: 'Dernières voies équipées',
    upcomingEvents: 'Événements à venir',
    ourMission: 'Notre mission',
    ourHistory: 'Notre histoire',
    supportUs: 'Soutenez-nous',
    donationAmount: 'Montant du don',
    customAmount: 'Montant personnalisé',
    loginAdmin: 'Connexion Admin',
    password: 'Mot de passe',
    login: 'Connexion',
    logout: 'Déconnexion',
    dashboard: 'Tableau de bord',
    settings: 'Paramètres',
    status: 'Statut',
    completed: 'Terminé',
    inProgress: 'En cours',
    date: 'Date',
    location: 'Lieu',
    category: 'Catégorie',
    tags: 'Tags',
    search: 'Rechercher',
    noResults: 'Aucun résultat',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    messageSent: 'Message envoyé avec succès',
    requiredField: 'Champ obligatoire',
    invalidEmail: 'Email invalide',
    heroTitle: 'ESCALADE EN SICILE',
    heroSubtitle: 'Découvrez les falaises de Caltavuturo',
    exploreNow: 'Explorer',
    climbingHistory: 'Histoire de l\'escalade',
    climbingHistoryText: 'Caltavuturo Climbing est né du précieux héritage laissé par Cabeci Climbing, un groupe historique de passionnés qui a contribué de manière décisive à l\'équipement de la plupart des falaises du territoire de Caltavuturo. De cette base solide naît une nouvelle génération de jeunes grimpeurs locaux, animés par la même passion et le désir de valoriser un patrimoine vertical unique.\n\nL\'association s\'engage à promouvoir l\'escalade sportive comme discipline, style de vie et occasion de rencontre avec la nature, en menant des projets d\'ouverture et d\'équipement de nouvelles voies dans des falaises encore inexplorées. Parallèlement, elle organise des événements, des rassemblements et des journées dédiées à la diffusion de la culture de l\'escalade, avec l\'objectif de faire connaître les extraordinaires parois des Madonie au niveau régional, national et international.\n\nCaltavuturo Climbing est communauté, passion et vision : un point de référence pour ceux qui vivent la roche avec respect, enthousiasme et esprit de partage, le regard toujours tourné vers de nouvelles lignes à tracer et de nouveaux horizons à atteindre.',
    homeHistoryText: 'Caltavuturo Climbing est un groupe de jeunes grimpeurs de Caltavuturo unis par leur amour du rocher et de nos montagnes. Nous perpétuons l\'héritage de Cabeci Climbing, en prenant soin des falaises existantes et en développant de nouvelles voies pour faire grandir l\'escalade sportive sur le territoire.\n\nAvec des événements, des rassemblements et de nouveaux projets, nous voulons partager la beauté de l\'escalade dans les Madonie et faire découvrir ces parois à ceux qui viennent de près ou de loin. Pour nous, c\'est passion, communauté et liberté verticale.',
    missionTitle: 'Notre mission',
    missionText: 'Promouvoir l\'escalade sportive en Sicile, développer de nouveaux secteurs, entretenir les falaises existantes et créer une communauté inclusive de grimpeurs.',
    donationCTA: 'Aidez-nous à développer de nouvelles voies',
    footerText: 'Association sportive dédiée à la promotion de l\'escalade en Sicile.',
  },
  de: {
    home: 'Startseite',
    team: 'Das Team',
    aboutUs: 'Über uns',
    projects: 'Projekte',
    events: 'Veranstaltungen',
    blog: 'Blog',
    gallery: 'Galerie',
    crags: 'Klettergärten',
    howToArrive: 'Anfahrt',
    accommodation: 'Unterkunft',
    donations: 'Spenden',
    contact: 'Kontakt',
    readMore: 'Weiterlesen',
    viewAll: 'Alle anzeigen',
    donate: 'Jetzt spenden',
    send: 'Senden',
    name: 'Name',
    email: 'E-Mail',
    message: 'Nachricht',
    subject: 'Betreff',
    phone: 'Telefon',
    address: 'Adresse',
    routes: 'Routen',
    grade: 'Schwierigkeit',
    length: 'Länge',
    type: 'Typ',
    exposure: 'Ausrichtung',
    rockType: 'Gesteinsart',
    approachTime: 'Zustiegszeit',
    pathType: 'Wegtyp',
    gpsCoordinates: 'GPS-Koordinaten',
    totalRoutes: 'Gesamte Routen',
    gradeRange: 'Schwierigkeitsbereich',
    filterByGrade: 'Nach Schwierigkeit filtern',
    allGrades: 'Alle Schwierigkeiten',
    latestRoutes: 'Neueste eingerichtete Routen',
    upcomingEvents: 'Kommende Veranstaltungen',
    ourMission: 'Unsere Mission',
    ourHistory: 'Unsere Geschichte',
    supportUs: 'Unterstützen Sie uns',
    donationAmount: 'Spendenbetrag',
    customAmount: 'Eigener Betrag',
    loginAdmin: 'Admin-Anmeldung',
    password: 'Passwort',
    login: 'Anmelden',
    logout: 'Abmelden',
    dashboard: 'Dashboard',
    settings: 'Einstellungen',
    status: 'Status',
    completed: 'Abgeschlossen',
    inProgress: 'In Bearbeitung',
    date: 'Datum',
    location: 'Ort',
    category: 'Kategorie',
    tags: 'Tags',
    search: 'Suchen',
    noResults: 'Keine Ergebnisse',
    loading: 'Wird geladen...',
    error: 'Fehler',
    success: 'Erfolg',
    messageSent: 'Nachricht erfolgreich gesendet',
    requiredField: 'Pflichtfeld',
    invalidEmail: 'Ungültige E-Mail',
    heroTitle: 'KLETTERN AUF SIZILIEN',
    heroSubtitle: 'Entdecken Sie die Klettergärten von Caltavuturo',
    exploreNow: 'Jetzt erkunden',
    climbingHistory: 'Klettergeschichte',
    climbingHistoryText: 'Caltavuturo Climbing entstand aus dem wertvollen Erbe von Cabeci Climbing, einer historischen Gruppe von Enthusiasten, die maßgeblich zur Erschließung der meisten Klettergärten im Gebiet von Caltavuturo beigetragen hat. Aus dieser soliden Basis entsteht eine neue Generation junger lokaler Kletterer, angetrieben von der gleichen Leidenschaft und dem Wunsch, ein einzigartiges vertikales Erbe zu würdigen.\n\nDer Verein setzt sich für die Förderung des Sportkletterns als Disziplin, Lebensstil und Gelegenheit zur Begegnung mit der Natur ein und führt Projekte zur Erschließung und Einrichtung neuer Routen in noch unerforschten Klettergärten durch. Gleichzeitig organisiert er Veranstaltungen, Treffen und Tage, die der Verbreitung der Kletterkultur gewidmet sind, mit dem Ziel, die außergewöhnlichen Wände der Madonie auf regionaler, nationaler und internationaler Ebene bekannt zu machen.\n\nCaltavuturo Climbing ist Gemeinschaft, Leidenschaft und Vision: ein Bezugspunkt für alle, die den Fels mit Respekt, Begeisterung und Gemeinschaftsgeist erleben, den Blick stets auf neue Linien und neue Horizonte gerichtet.',
    homeHistoryText: 'Caltavuturo Climbing ist eine Gruppe junger Kletterer aus Caltavuturo, die durch ihre Liebe zum Fels und zu unseren Bergen vereint sind. Wir führen das Erbe von Cabeci Climbing weiter, indem wir bestehende Klettergärten pflegen und neue Routen erschließen, um das Sportklettern in der Region zu fördern.\n\nMit Veranstaltungen, Treffen und neuen Projekten möchten wir die Schönheit des Kletterns in den Madonie teilen und diese Wände denen näherbringen, die von nah und fern kommen. Für uns bedeutet es Leidenschaft, Gemeinschaft und vertikale Freiheit.',
    missionTitle: 'Unsere Mission',
    missionText: 'Sportklettern auf Sizilien fördern, neue Sektoren erschließen, bestehende Klettergärten pflegen und eine inklusive Klettergemeinschaft schaffen.',
    donationCTA: 'Helfen Sie uns, neue Routen zu erschließen',
    footerText: 'Sportverein zur Förderung des Kletterns auf Sizilien.',
  },
  es: {
    home: 'Inicio',
    team: 'El Equipo',
    aboutUs: 'Quiénes somos',
    projects: 'Proyectos',
    events: 'Eventos',
    blog: 'Blog',
    gallery: 'Galería',
    crags: 'Sectores',
    howToArrive: 'Cómo llegar',
    accommodation: 'Alojamiento',
    donations: 'Donaciones',
    contact: 'Contacto',
    readMore: 'Leer más',
    viewAll: 'Ver todo',
    donate: 'Donar ahora',
    send: 'Enviar',
    name: 'Nombre',
    email: 'Email',
    message: 'Mensaje',
    subject: 'Asunto',
    phone: 'Teléfono',
    address: 'Dirección',
    routes: 'Vías',
    grade: 'Grado',
    length: 'Longitud',
    type: 'Tipo',
    exposure: 'Orientación',
    rockType: 'Tipo de roca',
    approachTime: 'Tiempo de aproximación',
    pathType: 'Tipo de sendero',
    gpsCoordinates: 'Coordenadas GPS',
    totalRoutes: 'Vías totales',
    gradeRange: 'Rango de grados',
    filterByGrade: 'Filtrar por grado',
    allGrades: 'Todos los grados',
    latestRoutes: 'Últimas vías equipadas',
    upcomingEvents: 'Próximos eventos',
    ourMission: 'Nuestra misión',
    ourHistory: 'Nuestra historia',
    supportUs: 'Apóyanos',
    donationAmount: 'Importe de la donación',
    customAmount: 'Importe personalizado',
    loginAdmin: 'Acceso Admin',
    password: 'Contraseña',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    dashboard: 'Panel',
    settings: 'Configuración',
    status: 'Estado',
    completed: 'Completado',
    inProgress: 'En progreso',
    date: 'Fecha',
    location: 'Ubicación',
    category: 'Categoría',
    tags: 'Etiquetas',
    search: 'Buscar',
    noResults: 'Sin resultados',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    messageSent: 'Mensaje enviado con éxito',
    requiredField: 'Campo obligatorio',
    invalidEmail: 'Email inválido',
    heroTitle: 'ESCALADA EN SICILIA',
    heroSubtitle: 'Descubre los sectores de Caltavuturo',
    exploreNow: 'Explorar ahora',
    climbingHistory: 'Historia de la escalada',
    climbingHistoryText: 'Caltavuturo Climbing nace del valioso legado dejado por Cabeci Climbing, un grupo histórico de apasionados que contribuyó de manera decisiva al equipamiento de la mayoría de los sectores presentes en el territorio de Caltavuturo. De esta base sólida nace una nueva generación de jóvenes escaladores locales, animados por la misma pasión y el deseo de valorizar un patrimonio vertical único.\n\nLa asociación se compromete a promover la escalada deportiva como disciplina, estilo de vida y ocasión de encuentro con la naturaleza, llevando adelante proyectos de apertura y equipamiento de nuevas vías en sectores aún inexplorados. Paralelamente organiza eventos, encuentros y jornadas dedicadas a la difusión de la cultura de la escalada, con el objetivo de dar a conocer las extraordinarias paredes de las Madonie a nivel regional, nacional e internacional.\n\nCaltavuturo Climbing es comunidad, pasión y visión: un punto de referencia para quienes viven la roca con respeto, entusiasmo y espíritu de compartir, con la mirada siempre puesta en nuevas líneas por trazar y nuevos horizontes por alcanzar.',
    homeHistoryText: 'Caltavuturo Climbing es un grupo de jóvenes escaladores de Caltavuturo unidos por su amor por la roca y nuestras montañas. Continuamos el legado de Cabeci Climbing, cuidando los sectores existentes y desarrollando nuevas vías para hacer crecer la escalada deportiva en el territorio.\n\nCon eventos, encuentros y nuevos proyectos, queremos compartir la belleza de escalar en las Madonie y dar a conocer estas paredes a quienes vienen de cerca y de lejos. Para nosotros es pasión, comunidad y libertad vertical.',
    missionTitle: 'Nuestra misión',
    missionText: 'Promover la escalada deportiva en Sicilia, desarrollar nuevos sectores, mantener los existentes y crear una comunidad inclusiva de escaladores.',
    donationCTA: 'Ayúdanos a desarrollar nuevas vías',
    footerText: 'Asociación deportiva dedicada a promover la escalada en Sicilia.',
  },
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('it');

  useEffect(() => {
    const savedLang = localStorage.getItem('caltavuturo-lang');
    if (savedLang && LANGUAGES[savedLang]) {
      setLanguage(savedLang);
    } else {
      // Try to detect browser language
      const browserLang = navigator.language.split('-')[0];
      if (LANGUAGES[browserLang]) {
        setLanguage(browserLang);
      }
    }
  }, []);

  const changeLanguage = (lang) => {
    if (LANGUAGES[lang]) {
      setLanguage(lang);
      localStorage.setItem('caltavuturo-lang', lang);
    }
  };

  const t = (key) => {
    return UI_TRANSLATIONS[language]?.[key] || UI_TRANSLATIONS['it'][key] || key;
  };

  const getTranslatedContent = (content) => {
    if (!content) return '';
    if (typeof content === 'string') return content;
    return content[language] || content['it'] || content['en'] || '';
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      changeLanguage, 
      t, 
      getTranslatedContent,
      languages: LANGUAGES 
    }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
